import React, { createContext, useCallback, useEffect, useState } from "react";
import { getMenu } from "../api/menuApi";
import useAuth from "../hooks/useAuth";

export const MenuContext = createContext(null);

/**
 * Loads the current user's permission-filtered menu once after login (see
 * MenuController#getMenuForCurrentUser on the backend) so the sidebar and
 * routing are data-driven, per the migration plan, instead of a hand-written
 * list of routes.
 */
export function MenuProvider({ children }) {
  const { user } = useAuth();
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(() => {
    if (!user) {
      setMenu([]);
      return;
    }
    setLoading(true);
    getMenu()
      .then(setMenu)
      .catch(() => setMenu([]))
      .finally(() => setLoading(false));
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <MenuContext.Provider value={{ menu, loading, refresh }}>{children}</MenuContext.Provider>;
}
